import styled from '@emotion/styled';

export default styled.p`
  text-align: center;
  color: var(--red);
`;
